module.exports = __webpack_public_path__ + "img/mod_9.c60fdd13.png";